import type { ImageProps } from 'next/image'
import NextImage from 'next/image'
import React from 'react'

import DefaultImage from '/public/images/toolkits/solid-color-image.png'

const getImageSrc = (src: string) => {
  if (src?.[0] === '/') {
    return `${process.env.NEXT_PUBLIC_PATH_PREFIX}${src}`
  }
  return src
}

const Image = ({
  src,
  fallback,
  ...props
}: ImageProps & { fallback?: ImageProps['src'] }) => {
  const parsedFallback =
    typeof fallback === 'string' ? getImageSrc(fallback) : fallback
  const [imgSrc, setImgSrc] = React.useState<ImageProps['src']>(
    typeof src === 'string' ? getImageSrc(src) : src
  )
  return (
    <NextImage
      key={imgSrc?.toString()}
      src={imgSrc || parsedFallback || DefaultImage}
      onError={() => {
        setImgSrc(parsedFallback || DefaultImage)
      }}
      {...props}
    />
  )
}

export default Image
